import React, { useState } from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { colors } from "theme/Theme";

interface DeliveryMethodProps {
  register: any;
  setShowTransferInfo: any;
}

const options = [
  // {
  //   title: "Плащане чрез EPay.bg",
  //   name: "paymentType",
  //   value: "ePay",
  // },
  {
    title: "Плащане при доставка",
    name: "paymentType",
    value: "При доставка",
  },
  {
    title: "Банков трансфер",
    name: "paymentType",
    value: "Банков трансфер",
  },
];

const DeliveryMethod: React.FC<DeliveryMethodProps> = ({ register, setShowTransferInfo }) => {
  const [optionSelected, setOptionSelected] = useState(options[0].name);

  const onClick = (event: any) => {
    setShowTransferInfo(event.target.value === "Банков трансфер");
    setOptionSelected(event.target.value);
  };

  return (
    <CheckboxContainer>
      <span className="text-body form-title">Начин на плащане</span>
      <div className="options">
        {options.map((item, idx) => {
          return (
            <label key={idx}>
              <input
                type="radio"
                name={item.name}
                checked={optionSelected === item.value}
                onClick={onClick}
                ref={register()}
                value={item.value}
              />
              <span className="design"></span>
              <span className="text text-xs">{item.title}</span>
            </label>
          );
        })}
      </div>
    </CheckboxContainer>
  );
};

export const CheckboxContainer = styled.div`
  .form-title {
    width: 100%;
  }

  .options {
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;

    @media only screen and (${device.laptop}) {
      flex-flow: row nowrap;
      justify-content: space-between;
    }

    @media only screen and (${device.desktop}) {
      flex-flow: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }

  label {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;

    margin: 12px 0;

    cursor: pointer;
    position: relative;

    @media only screen and (${device.laptop}) {
      margin-right: 20px;
    }

    @media only screen and (${device.desktop}) {
      margin-right: 0;
    }
  }

  input {
    opacity: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
  }

  /* .design */
  .design {
    width: 12px;
    height: 12px;

    border: 1px solid black;
    border-radius: 100%;
    margin-right: 16px;

    position: relative;
  }

  .design::before,
  .design::after {
    content: "";
    display: block;

    width: inherit;
    height: inherit;

    border-radius: inherit;

    position: absolute;
    transform: scale(0);
    transform-origin: center center;
  }

  .design:before {
    background: ${colors.light_blue};
    opacity: 0;
    transition: 0.3s;
  }

  .design::after {
    background: ${colors.light_blue};
    opacity: 0.4;
    transition: 0.6s;
  }

  /* .text */
  .text {
    color: black;
  }

  /* checked state */
  input:checked + .design::before {
    opacity: 1;
    transform: scale(0.6);
  }

  input:checked + .design {
    border: 1px solid ${colors.light_blue};
  }

  /* other states */
  input:hover + .design,
  input:focus + .design {
    border: 1px solid ${colors.light_blue};
  }

  input:hover + .design:before,
  input:focus + .design:before {
    background: ${colors.light_blue};
  }

  input:hover ~ .text {
    color: ${colors.light_blue};
  }

  input:focus + .design::after,
  input:active + .design::after {
    opacity: 0.1;
    transform: scale(2);
  }

  @media only screen and (${device.laptopL}) {
    .design {
      width: 16px;
      height: 16px;
    }
  }
`;

export default DeliveryMethod;
